export enum ETextType {
  Web = 'web',
  App = 'app',
}
